import { ProfessionalServicesResponse } from './../model/remote-answer';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { RemoteAssessment } from 'app/model/remote-assessment';
import { map } from 'rxjs/operators';
import { SelfDeclaration } from 'app/model/self-declaration';
import { Observable } from 'rxjs';
import { PS } from 'app/model/ps';
import { Assessment } from 'app/model/assessment';
import { RemoteAnswer } from 'app/model/remote-answer';
import { Contact } from 'app/model/contact';
import { RegistrationRequest, RegistrationRequestResult } from 'app/model/RegistrationRequest';
import { Suburb } from 'app/model/suburbs';
import { RequestSource } from 'app/model/RequestSource';
import { SubmitAssessmentResult } from 'app/model/submitassessmentresult';
import { uploadDocument } from 'app/model/uploadDocument';
@Injectable({
  providedIn: 'root'
})
export class CrmService {

  constructor(private http: HttpClient) { }

  GetAssessmentDetails(assessmentId, contactId): Observable<RemoteAssessment> {
    let url = environment.apiurl + "RemoteAssessment/" + assessmentId + "/" + contactId;

    return this.http.get(url).pipe(map(x => x as RemoteAssessment));
  }

  CreateSelfDeclaration(selfDeclaratoion: SelfDeclaration): Observable<SelfDeclaration> {

    let url = environment.apiurl + "SelfDeclaration";
    var request = {SelfDeclaration:selfDeclaratoion};
    return this.http.post(url, request).pipe(map(x => x as SelfDeclaration));

  }

  UpdateProfessionalServices(
    assessment:Assessment,
    professiionalServices: PS[],
    contact:Contact,
    professionalServicesChecked?: PS[],
    levels?: number[]
  ): Observable<ProfessionalServicesResponse> {

    let url = environment.apiurl + "ProfessionalServices";
    var request: any = {ProfessionalServices:professiionalServices,Assessment:assessment,Contact:contact};
    if (professionalServicesChecked) {
      request.ProfessionalServicesChecked = professionalServicesChecked;
    }
    if (levels !== undefined) {
      request.Levels = levels;
    }
    return this.http.post(url, request).pipe(map(x => (x as ProfessionalServicesResponse)));

  }

  UploadDocument(filebase64:string,answerId:string,fileName:string):Observable<uploadDocument>{
    let url = environment.apiurl + "documents";
    var request = {File:filebase64,AnswerId:answerId,FileName:fileName};
    return this.http.post(url, request).pipe(map(x => (x as uploadDocument)));
  }

  GetDocument(answerId:string):Observable<string[]>{
    let url = environment.apiurl + "documents/" + answerId;
    return this.http.get(url).pipe(map(x => (x as any).fileNames as string[]));
  }

  DeleteDocument(answerId:string,documentName:string){
    let url = environment.apiurl + "documents?FileName=" + encodeURIComponent(documentName) + "&AnswerId=" + answerId;
    return this.http.delete(url).pipe(map(x => (x as any).fileNames as string[]));
  }

  SubmitAssessment(assessmentId:string):Observable<SubmitAssessmentResult>{
    let url = environment.apiurl + "submit/" + assessmentId;
    return this.http.get(url).pipe(map(x => x as SubmitAssessmentResult));
  }

  SaveAnswer(answer:RemoteAnswer){
    let url = environment.apiurl + "remote-answer/";
    var request={RemoteAnswer:answer}
    return this.http.post(url, request).pipe(map(x => (x as any).fileNames as string[]));
  }

  SubmitRegistrationRequest(registrationRequest:RegistrationRequest):Observable<RegistrationRequestResult>{
    let url = environment.apiurl + "registrationrequest/";
    var request={registration:registrationRequest}
    return this.http.post(url,request).pipe(map(x => x as RegistrationRequestResult));
  }

  GetSuburbs(){
    let url = environment.apiurl + "suburbs/";
    return this.http.get(url).pipe(map(x => x as Suburb[]));
  }

  GetRequestSource(){
    let url = environment.apiurl + "requestsource/";
    return this.http.get(url).pipe(map(x => x as RequestSource[]));
  }

}
